// extracted by mini-css-extract-plugin
export default {"withOverlay":"HeaderFooterOverlay_withOverlay__a2lzy","overlay":"HeaderFooterOverlay_overlay__0CQK+"};